import { AxiosError } from 'axios';
import log from 'loglevel';
import { useQuery, UseQueryResult } from 'react-query';
import { PositionEducation } from '../@types/position-education';
import { getEducation } from '../services/create-position.network-requests';

const logger = log.getLogger('CREATE_POSITION_EDUCATION_QUERIES');

export const useGetEducation = ():
UseQueryResult<PositionEducation> => {
  return useQuery(['education'], () => getEducation(), {
    onSuccess: () => {
      logger.debug('successfully got education');
    },
    onError: (error: AxiosError) => {
      const errorStatusCode = error?.response?.status || 999;
      const isInternalServerError = errorStatusCode > 499;
      if (isInternalServerError) {
        logger.error('Failed to get education status: ', errorStatusCode, error, { isInternalServerError });
      } else {
        logger.warn('Failed to get education status:', errorStatusCode, error, { isInternalServerError });
      }
    },
    retry: 0,
  });
};
